module.exports = __webpack_public_path__ + "media/images/game/categories/komunikace_a_media-dbe1497f25adeec997b9a28a33aa854f.png";